import * as React from 'react';
import {FunctionComponent} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import {WorkoutShowByToken} from './WorkoutShowByToken';

interface OwnProps {}

const GLOBAL = (window as any).DATA;

export const WorkoutShowByTokenContainer: FunctionComponent<OwnProps> = ({}) => {
    const {id} = useParams<{hash: string; id: string}>();
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <WorkoutShowByToken
            id={parseInt(id!, 10)}
            token={searchParams.get('token')!}
            previewWorkout={GLOBAL?.preview}
        />
    );
};
